import React from "react";
import { Grid, Typography, TextField, FormControl, RadioGroup, FormControlLabel, Radio, Divider, FormHelperText, Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import { blue } from "@mui/material/colors";
import { ImArrowUp, ImArrowDown } from "react-icons/im";

const useStyles = makeStyles((theme) => ({
    customLabel: {
        fontSize: "13px", // Adjust the font size as needed
        paddingTop: 1,
    },
    resize: {
        fontSize: 13,
    },
    root: {
        "& .MuiFormControl-root": {
            margin: 0,
        },
    },
    select: {
        "&:before": {
            borderColor: blue,
        },
        "&:after": {
            borderColor: "#008000",
        },
    },
}));

const FiveWOneHAnalysis = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const theme = useTheme();
    return (
        <Grid container xs={12} sm={6} md={6}>
            <Box
                sx={{
                    width: "98%",
                    px: 1,
                    py: 1,
                    m: 1,
                    mt: 0,
                    alignItems: "center",
                    backgroundColor: theme.palette.grey[100],
                    borderRadius: "12px",
                    boxShadow: 3,
                    gap: 2,
                }}
            >
                <Grid item xs={12} sm={12}>
                    <Typography variant="h6" align="center" sx={{ fontSize: 15, backgroundColor: "#DEE0E0" }}>
                        {t("5W1HAnalysis")}
                    </Typography>
                </Grid>

                <Grid container xs={12} sm={12}>
                    <Grid container xs={12} sm={12}>
                        {/* WHAT */}
                        <Grid container xs={12} sm={12} alignSelf="center" sx={{ backgroundColor: "#F5FB96" }}>
                            <Grid item xs={1} sm={1} alignSelf="center">
                                <Typography variant="h6" sx={{ fontSize: 14 }}>
                                    {t("What")}
                                </Typography>
                            </Grid>
                            <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                            <Grid item xs={3} sm={3}>
                                <Typography variant="h6" align="center" sx={{ fontSize: 12, padding: 2 }}>
                                    {t("WhichProductWasProcessed")}
                                </Typography>
                            </Grid>
                            <Grid item xs={8} sm={8} sx={{ display: "flex" }}>
                                <TextField
                                    size="large"
                                    type="primary"
                                    defaultValue=""
                                    InputProps={{
                                        classes: {
                                            input: classes.resize,
                                        },
                                    }}
                                    value={props.what}
                                    disabled={props.disableStates.isWhatDisable}
                                    onChange={props.handleWhatChange}
                                    multiline
                                    maxRows={2}
                                    sx={{ justifyContent: "center" }}
                                    fullWidth
                                    error={props.hasWhatError}
                                    helperText={props.whatErrorText}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Divider orientation="horizontal" flexItem sx={{ mb: "-1px" }} />
                            </Grid>

                            {/* WHEN */}
                            <Grid item xs={1} sm={1} alignSelf="center">
                                <Typography variant="h6" sx={{ fontSize: 14 }}>
                                    {t("When")}
                                </Typography>
                            </Grid>
                            <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                            <Grid item xs={3} sm={3}>
                                <Typography variant="h6" align="center" sx={{ fontSize: 12, padding: 2 }}>
                                    {t("WhenProblemsAreDeveloping")}
                                </Typography>
                            </Grid>
                            <Grid container xs={8} sm={8} alignItems="center" justifyContent="center">
                                <FormControl disabled={props.disableStates.isWhenDisable} error={props.selectedRadioValue == ""}>
                                    <RadioGroup row value={props.selectedRadioValue}>
                                        {props.operatorFiveWsOneHAnalysis.map((option, index) => (
                                            <Grid key={index} xs={2}>
                                                <FormControlLabel
                                                    labelPlacement="bottom"
                                                    value={option.id}
                                                    onChange={props.handleRadioChange}
                                                    control={<Radio size="small" />}
                                                    label={<span style={{ fontSize: "0.6rem" }}>{t(`WhenItems.${option.whenStatus}`)}</span>}
                                                    sx={{
                                                        m: 0, // root margin sıfır
                                                        alignItems: "center",
                                                        gap: "2px", // Radio ile label arasındaki boşluğu küçült
                                                        "& .MuiFormControlLabel-label": {
                                                            fontSize: "0.6rem",
                                                            lineHeight: 1.1, // satır aralığını daralt
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word",
                                                            textAlign: "center",
                                                            margin: 0, // ekstra marginleri kaldır
                                                            display: "block", // line-height düzgün uygulansın
                                                        },
                                                    }}
                                                />
                                            </Grid>
                                        ))}
                                    </RadioGroup>
                                    {props.selectedRadioValue === 0 && <FormHelperText>{t("EmptyCheck")}</FormHelperText>}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Divider orientation="horizontal" flexItem sx={{ mb: "-1px" }} />
                            </Grid>

                            {/* WHERE */}
                            <Grid item xs={1} sm={1} alignSelf="center">
                                <Typography variant="h6" sx={{ fontSize: 14 }}>
                                    {t("Where")}
                                </Typography>
                            </Grid>
                            <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                            <Grid item xs={3} sm={3} sx={{margin: "auto", padding: 1}}>
                                <Typography variant="h6" align="center" sx={{ fontSize: 12, padding: 2 }}>
                                    {t("WhichPartsOfAMachineOrProductTheProblemOccurs")}
                                </Typography>
                            </Grid>
                            <Grid item xs={8} sm={8} sx={{ display: "flex" }}>
                                <TextField
                                    size="large"
                                    type="primary"
                                    InputProps={{
                                        classes: {
                                            input: classes.resize,
                                        },
                                    }}
                                    disabled={props.disableStates.isWhereDisable}
                                    value={props.where}
                                    onChange={props.handleWhereChange}
                                    multiline
                                    rows={2}
                                    maxRows={2}
                                    sx={{ justifyContent: "center" }}
                                    fullWidth
                                    error={props.hasWhereError}
                                    helperText={props.whereErrorText}
                                ></TextField>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Divider orientation="horizontal" flexItem sx={{ mb: "-1px" }} />
                            </Grid>

                            {/* WHO */}
                            <Grid item xs={1} sm={1} alignSelf="center">
                                <Typography variant="h6" sx={{ fontSize: 14 }}>
                                    {t("Who")}
                                </Typography>
                            </Grid>
                            <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                            <Grid item xs={3} sm={3}>
                                <Typography variant="h6" align="center" sx={{ fontSize: 12, padding: 2 }}>
                                    {t("WasTheOperatorNewToThatWork")}
                                </Typography>
                            </Grid>
                            <Grid item xs={8} sm={8} sx={{ display: "flex" }}>
                                <TextField
                                    InputProps={{
                                        classes: {
                                            input: classes.resize,
                                        },
                                    }}
                                    disabled={props.disableStates.isWhoDisable}
                                    value={props.who}
                                    onChange={props.handleWhoChange}
                                    size="large"
                                    type="primary"
                                    multiline
                                    rows={2}
                                    maxRows={2}
                                    sx={{ justifyContent: "center" }}
                                    fullWidth
                                    error={props.hasWhoError}
                                    helperText={props.whoErrorText}
                                ></TextField>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Divider orientation="horizontal" flexItem sx={{ mb: "-1px" }} />
                            </Grid>

                            {/* WHICH */}
                            <Grid item xs={1} sm={1} alignSelf="center">
                                <Typography variant="h6" sx={{ fontSize: 14}}>
                                    {t("Which")}
                                </Typography>
                            </Grid>
                            <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                            <Grid item xs={3} sm={3}>
                                <Typography variant="h6" align="center" sx={{ fontSize: 12, padding: 2 }}>
                                    {t("FailureWasPrecededByAnySymptom")}
                                </Typography>
                            </Grid>
                            <Grid item xs={8} sm={8} md={8} alignSelf="center">
                                <Grid container xs={12} sm={12} md={12}>
                                    <Grid xs={5} sm={5} md={5}>
                                        <FormControl disabled={props.disableStates.isWhichRadioDisable}>
                                            <RadioGroup row onChange={props.handleWhichRadioChange} defaultValue="female" name="radio-buttons-group">
                                                <Grid xs={2} sm={2} md={2} sx={{ margin: "auto" }}>
                                                    <FormControlLabel
                                                        size="small"
                                                        value="0"
                                                        control={<Radio size="small" sx={{ paddingRight: 0 }} />}
                                                        label={<span style={{ fontSize: "0.7rem" }}>{t("No")}</span>}
                                                    />
                                                </Grid>
                                                <Grid xs={3} sm={3} md={3} sx={{ margin: "auto" }}>
                                                    <FormControlLabel
                                                        value="1"
                                                        control={<Radio size="small" sx={{ paddingRight: 0, paddingLeft: 1 }} />}
                                                        label={<span style={{ fontSize: "0.7rem" }}>{t("YesWhich")}</span>}
                                                    />
                                                </Grid>
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                    <Grid xs={7} sm={7} md={7}>
                                        <TextField
                                            size="large"
                                            type="primary"
                                            InputProps={{
                                                classes: {
                                                    input: classes.resize,
                                                },
                                            }}
                                            disabled={props.disableStates.isWhichDisable}
                                            multiline
                                            rows={2}
                                            maxRows={2}
                                            sx={{ justifyContent: "center" }}
                                            fullWidth
                                            value={props.which}
                                            onChange={props.handleWhichChange}
                                            error={props.hasWhichError}
                                            helperText={props.whichErrorText}
                                        ></TextField>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Divider orientation="horizontal" flexItem sx={{ mb: "-1px" }} />
                            </Grid>

                            {/* HOW */}
                            <Grid item xs={1} sm={1} alignSelf="center">
                                <Typography variant="h6" sx={{ fontSize: 14 }}>
                                    {t("How")}
                                </Typography>
                            </Grid>
                            <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                            <Grid item xs={3} sm={3} sx={{margin: "auto"}}>
                                <Typography variant="h6" align="center" sx={{ fontSize: 12, padding: 4 }}>
                                    {t("WhatAreTheImplicationsForTheFunctionalityOfTheDevice")}
                                </Typography>
                            </Grid>
                            <Grid item xs={8} sm={8} sx={{ display: "flex" }}>
                                <TextField
                                    size="large"
                                    type="primary"
                                    InputProps={{
                                        classes: {
                                            input: classes.resize,
                                        },
                                    }}
                                    disabled={props.disableStates.isHowDisable}
                                    value={props.how}
                                    onChange={props.handleHowChange}
                                    multiline
                                    rows={2}
                                    maxRows={2}
                                    sx={{ justifyContent: "center" }}
                                    fullWidth
                                    error={props.hasHowError}
                                    helperText={props.howErrorText}
                                ></TextField>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {/*PART TO FILL ALONG WITH OPERATOR*/}
                <Grid item xs={12} sm={12}>
                    <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                        <ImArrowUp />
                        {t("PartToFillAlongWithOperator")}
                        <ImArrowUp />
                    </Typography>
                </Grid>
                {/*PART TO FILL BY MAINTENANCE DEPARTMENT*/}
                <Grid item xs={12} sm={12}>
                    <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                        <ImArrowDown />
                        {t("PartToFillByMaintenanceDepartment")}
                        <ImArrowDown />
                    </Typography>
                </Grid>
                {/*DESCRIPTION OF ACTIVITIES*/}
                <Grid item xs={12} sm={12}>
                    <Grid container xs={12} sm={12} padding={1}>
                        <Grid item xs={12} sm={12} md={12}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                {t("DescriptionOfActivities")}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <TextField
                                size="large"
                                type="primary"
                                InputProps={{
                                    classes: {
                                        input: classes.resize,
                                    },
                                }}
                                disabled={props.disableStates.isDescriptionOfActivitiesDisable}
                                value={props.descriptionOfActivities}
                                onChange={props.handleDescriptionOfActivitiesChange}
                                multiline
                                rows={4}
                                sx={{ justifyContent: "center" }}
                                fullWidth
                                error={props.hasDescriptionError}
                                helperText={props.descriptionErrorText}
                            ></TextField>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};

export default FiveWOneHAnalysis;
